import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { RecommendationMentorCardProps } from './interface';
import { MentorCardComponent } from '../mentor-card';

export const RecommendationMentorCard: FC<RecommendationMentorCardProps> = ({
  mentor,
  onShow,
}) => {
  const [t, i18n] = useTranslation();

  const {
    id,
    name,
    details: { profileImage, description, education, focusTopics, languages },
  } = mentor ?? { details: {} };

  const languageLabel = new Intl.DisplayNames([i18n.language], {
    type: 'language',
  });
  const languageList = languages?.map(
    (lang) => languageLabel.of(lang) as string,
  );
  const focusTopicList = focusTopics?.map((item) =>
    t(`v2.global.chip_label_topic_${item}`),
  );

  return (
    <MentorCardComponent
      id={id}
      baseWidth={300}
      onClick={onShow}
      profileImage={profileImage}
      name={name}
      education={education}
      description={description}
      languages={languageList}
      focusTopics={focusTopicList}
    />
  );
};
